import {useParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {getEventNew} from "../../../../../data/api/Customer";
import {EventModelNew} from "../../../../../data/model/Event";
import '../../../../../../node_modules/react-calendar/dist/Calendar.css';
import {
    chakra,
    HStack,
    Image,
    Skeleton,
    SkeletonText,
    Stack,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Tr,
    VStack
} from "@chakra-ui/react";
import {BackButtonComponent} from "../../../../../components/molecules/BackButton/BackButtonComponent";
import {EmailIcon, LinkIcon, PhoneIcon} from "@chakra-ui/icons";
import * as React from "react";
import Calendar from "react-calendar";
import './Calendar.css';
import {scrollbarCss} from "../../../../../theme/theme";
import {getFormattedData} from "../../../../../utils/Utils";
import {BaseResponse} from "../../../../../data/model/BaseResponse";

export const EventDetailsPage = () => {
    const {id} = useParams();
    const response = useQuery({queryKey: ["get-events-mine", id], queryFn: () => getEventNew(id)})
    const {data, isLoading} = response || {};
    const eventResponse = data?.data as BaseResponse<EventModelNew> || {};
    const {
        startDate: sd,
        endDate: ed,
        lat,
        long,
        contactEmail,
        contactPhone,
        contactWeb
    } = eventResponse.data || {};

    const startDate = new Date((sd as number));
    const endDate = new Date((ed as number));

    return <VStack w={"100%"} h={"100%"} overflow={"hidden"}>
        <BackButtonComponent/>
        <HStack w={"100%"} h={"100%"} spacing={0} overflow={"auto"} css={scrollbarCss}>
            <VStack h={"100%"} w={"60%"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                {isLoading ? <EventDetailLoading/> : <EventDetailSection event={eventResponse.data}/>}
            </VStack>
            {isLoading && <VStack h={"100%"} w={"35%"} maxW={"35%"} alignItems={"center"} justifyContent={"center"}
                                  spacing={"24px"}>
                <Skeleton borderRadius={"16px"} w={"70%"} aspectRatio={1}/>
            </VStack>}
            {!isLoading &&
                <VStack h={"100%"} py={24} w={"35%"} display={"inline-block"} maxW={"35%"} alignItems={"center"}
                        justifyContent={"center"}
                        spacing={"24px"}>

                    <Text textColor={"primary.400"} fontSize={"20px"} fontWeight={"bold"} mb={"8px"}>Quando</Text>
                    <Calendar selectRange={true} className={"react-calendar-container"}
                              value={[startDate, endDate]} minDate={startDate}
                              maxDate={endDate}/>

                    {startDate && endDate && <chakra.hr mt={"24px"}/>}

                    {(startDate || endDate) &&
                        <HStack w={"100%"} mt={"24px"} display={"flex"}>
                            <Text fontWeight={"bold"} textColor={"darkcyan"}>Inizia alle:</Text><Text
                            fontWeight={"bold"}>{getFormattedData(startDate)}</Text>
                            {getFormattedData(endDate) &&
                                <HStack><Text ms={"24px"} fontWeight={"bold"} textColor={"darkcyan"}>Termina
                                    alle:</Text><Text
                                    fontWeight={"bold"}>{getFormattedData(endDate)}</Text></HStack>}
                        </HStack>
                    }

                    {(lat || long) && <chakra.hr mt={"24px"}/>}

                    {(lat || long) && <Text textColor={"primary.400"} fontSize={"20px"} fontWeight={"bold"} mt={"16px"}
                                            mb={"8px"}>Dove</Text>}

                    {(lat || long) && <chakra.iframe w={"95%"} mt={"16px"} height={"350px"} borderRadius={"16px"}
                                                     border={"1px solid #a0a096"}
                                                     src={'https://maps.google.com/maps?q=' + lat + ',' + long + '&t=&z=15&ie=UTF8&iwloc=&output=embed'}></chakra.iframe>}

                    {(contactEmail || contactPhone || contactWeb) && <chakra.hr mt={"32px"}/>}

                    {(contactEmail || contactPhone || contactWeb) && <Stack py={"24px"}>
                        <Text fontSize={"20px"} fontWeight={"bold"} textColor={"primary.400"}>Contatti</Text>
                        <VStack borderRadius={"16px"} p={"24px"} mt={"16px"} justifyContent={"center"}
                                backgroundColor={"surfaceContainer.light"} w={"95%"}>
                            <TableContainer alignSelf={"center"}>
                                <Table>
                                    <Tbody>
                                        {contactEmail && <Tr>
                                            <Td><EmailIcon/></Td>
                                            <Td><Text>{contactEmail}</Text></Td>
                                        </Tr>}
                                        {contactPhone && <Tr>
                                            <Td><PhoneIcon/></Td>
                                            <Td><Text>{contactPhone}</Text></Td>
                                        </Tr>}
                                        {contactWeb && <Tr>
                                            <Td><LinkIcon/></Td>
                                            <Td><Text>{contactWeb}</Text></Td>
                                        </Tr>}
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </VStack>
                    </Stack>}
                </VStack>}
        </HStack>
    </VStack>
}

export const EventDetailLoading = () => {
    return <Stack w={"100%"} px={"15%"} py={"48px"} spacing={"8px"} overflowY={"auto"}>
        <Skeleton h={"24px"} w={"25%"} fontWeight={"bold"}/>
        <Skeleton h={"48px"} w={"75%"} fontWeight={"bold"}/>
        <Skeleton h={"24px"} w={"35%"}/>

        <Skeleton h={"24px"} w={"20%"} mt={"24px"}/>
        <Skeleton h={"72px"} w={"15%"} mt={"8px"} ms={"8px"}/>

        <SkeletonText skeletonHeight={"24px"} noOfLines={10} fontSize={"16px"} mt={"24px"}/>
    </Stack>
}

const EventDetailSection = ({event}: { event?: EventModelNew }) => {
    const {
        title,
        description,
        location,
        price,
        mediaList
    } = event || {};

    return <VStack w={"100%"} px={"15%"} my={"48px"} spacing={"8px"}>
        <Text fontSize={"16px"} fontWeight={"bold"}>{location}</Text>
        <Text fontSize={"32px"} color={"primary.400"} fontWeight={"bold"}>{title}</Text>

        <Image backgroundColor={"white"} borderRadius={"16px"} mt={"16px"} objectFit={"fill"}
               boxShadow={"1px 1px 10px rgba(0,0,0,0.1)"} src={mediaList?.[0]?.url} w={"100%"}/>

        <HStack w={"100%"} mt={"24px"}>
            <Text alignSelf={"center"} fontWeight={"bold"} fontSize={"20px"} textColor={"primary.400"}
                  textAlign={"start"}>Prezzo</Text>
            <Text alignSelf={"center"} ms={"16px"} fontSize={"24px"} fontWeight={"bold"}
                  textAlign={"center"}>{price ? `${price}€` : "Gratis"}</Text>
        </HStack>

        <Text dangerouslySetInnerHTML={{__html: description || ""}} mt={"24px"}/>
    </VStack>
}

